"use client";
import { MinimalLiveVideoSkin as MinimalLiveVideoSkin$1 } from "../../internal/skins/minimal-live-video/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/live-video/minimal-skin.tsx
function MinimalLiveVideoSkin(props) {
	return /* @__PURE__ */ jsx(MinimalLiveVideoSkin$1, { ...props });
}
//#endregion
export { MinimalLiveVideoSkin };

//# sourceMappingURL=minimal-skin.js.map